import React from 'react'

const WaveContainer = ({ ID, CLASSES, children }) => {
    const sectionClasses =
        CLASSES +
        ' bg-[#E2800F] flex justify-center items-center px-2 md:px-0 relative'
    return (
        <section className={sectionClasses} id={ID}>
            <div className="col-span-full waveContainer normal">
                <svg
                    className="waves"
                    viewBox="0 24 150 28"
                    preserveAspectRatio="none"
                >
                    <defs>
                        <path
                            id="gentle-wave"
                            d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
                        />
                    </defs>
                    <g className="parallax">
                        <use
                            href="#gentle-wave"
                            x="48"
                            y="0"
                            fill="rgba(226, 128, 15,0.7"
                        />
                        <use
                            href="#gentle-wave"
                            x="48"
                            y="3"
                            fill="rgba(226, 128, 15,0.5)"
                        />
                        <use
                            href="#gentle-wave"
                            x="48"
                            y="5"
                            fill="rgba(226, 128, 15,0.3)"
                        />
                        <use
                            href="#gentle-wave"
                            x="48"
                            y="7"
                            fill="rgb(226, 128, 15)"
                        />
                    </g>
                </svg>
            </div>
            {children}
            <div className="col-span-full waveContainer fliped">
                <svg
                    className="waves"
                    viewBox="0 24 150 28"
                    preserveAspectRatio="none"
                >
                    <defs>
                        <path
                            id="gentle-wave"
                            d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
                        />
                    </defs>
                    <g className="parallax">
                        <use
                            href="#gentle-wave"
                            x="48"
                            y="0"
                            fill="rgba(226, 128, 15,0.7"
                        />
                        <use
                            href="#gentle-wave"
                            x="48"
                            y="3"
                            fill="rgba(226, 128, 15,0.5)"
                        />
                        <use
                            href="#gentle-wave"
                            x="48"
                            y="5"
                            fill="rgba(226, 128, 15,0.3)"
                        />
                        <use
                            href="#gentle-wave"
                            x="48"
                            y="7"
                            fill="rgb(226, 128, 15)"
                        />
                    </g>
                </svg>
            </div>
        </section>
    )
}

export default WaveContainer
